import { i18nKeyType } from '../../i18n';

export enum AppFeatureKey {
  WELDING_ENHANCED_STITCH = 'welding_enhanced_stitch',
  WELDING_FINE_TUNE = 'welding_fine_tune',
  WELDING_MULTIPASS = 'welding_multipass',
}

interface FeatureTourPromotionDetail {
  title: i18nKeyType;
  description?: i18nKeyType;
}

export const FeatureTourPromotionDetails: Record<
  AppFeatureKey,
  FeatureTourPromotionDetail
> = {
  [AppFeatureKey.WELDING_ENHANCED_STITCH]: {
    title: 'welding:enhanced_stitch_tour_title',
    description: 'welding:enhanced_stitch_tour_description',
  },
  [AppFeatureKey.WELDING_FINE_TUNE]: {
    title: 'welding:fine_tune_tour_title',
  },
  [AppFeatureKey.WELDING_MULTIPASS]: {
    title: 'welding:multipass_tour_title',
    description: 'welding:multipass_tour_description',
  },
};
